import {useReducer, useEffect} from "react"
import {NwDashboardContext} from "../contexts/NwDashboardContext"
import nwDashboardReducer from '../reducers/nwDashboardReducer'

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null
    },
    teamPage: 1,
    projectPage: 1,
}

export default function NwDashboardProvider({children}) {
    const [nwDashboardContext, setNwDashboardAction] = useReducer(
        nwDashboardReducer,
        initialState,
    )

    useEffect(() => {
        if (nwDashboardContext) {
            localStorage.setItem("nwDashboardContext", JSON.stringify(nwDashboardContext))
        } else {
            localStorage.removeItem("nwDashboardContext")
        }
    }, [nwDashboardContext])

    return (
        <NwDashboardContext.Provider value={{nwDashboardContext, setNwDashboardAction}}>
            {children}
        </NwDashboardContext.Provider>
    )
}